module.exports = __webpack_public_path__ + "static/media/rv_large.fccf7461.jpeg";